import { BoardTimeline } from '../../model/board-timeline';

export function getTransitionYearsFromTimeline(timeline: BoardTimeline): number[] {
  const years = [];
  for (let year = timeline.scenarioStartYear; year <= timeline.boardEndYear; year++) {
    years.push(year);
  }
  return years;
}
